var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('change-contact',{attrs:{"is-from-settings":true,"item":_vm.currentCollective,"type":_vm.getType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }